<template>
    <BasicDialog>
        <div class="d-flex flex-column ga-5">

            <MyRewardBasicInformation />
            <MyRewardInformation />


            <v-divider />


            <MyRewardRedeemAction v-if="selectedMyPayoutData.current_state.state_name === 'Fulfilled'" />


            <ErrorMessage v-if="selectedMyPayoutData.current_state.state_name !== 'Fulfilled'"
                :errorMessage="selectedMyPayoutData.message"/>
            <SuccessMessage v-else :successMessage="selectedMyPayoutData.message"/>


            <MyRewardRedeemInstructions v-if="selectedMyPayoutData.reward_data" />


            <DisclaimerComponent>
                {{ selectedMyPayoutData.payout_option.disclaimer }}
            </DisclaimerComponent>


        </div>
    </BasicDialog>
</template>



<script setup lang="ts">

import { computed } from "vue";
import { PayoutStore } from "@/store/PayoutStore";
import MyRewardInformation from "./MyReward-Information.vue";
import BasicDialog from "@/components/Common/Basic-Dialog.vue";
import MyRewardRedeemAction from "./MyReward-Redeem-Action.vue";
import DisclaimerComponent from "@/components/Common/Disclaimer.vue";
import MyRewardBasicInformation from "./MyReward-BasicInformation.vue";
import MyRewardRedeemInstructions from "./MyReward-Redeem-Instructions.vue";
import ErrorMessage from "@/components/Auth/Common/Messeges/ErrorMessage.vue";
import SuccessMessage from "@/components/Auth/Common/Messeges/SuccessMessage.vue";

const payoutStore = PayoutStore();

const selectedMyPayoutData = computed(() => {
    return payoutStore.SelectedMyPayoutData;
});

</script>